
import { defineComponent } from "vue";
import {
  ExpiringPoints,
  GtrLifestyleBonus,
  PointsHistory,
  RankRequalification,
} from "@/components/qualification-dashboard";
import { mapGetters } from "vuex";
import {
  doGetExpiringPoints,
  doGetGtrLifeBonus,
  doGetPointsHistory,
} from "@/store/RankQualification/RankQualificationInterfaces";

export default defineComponent({
  name: "qualification-dashboard",
  components: {
    ExpiringPoints,
    GtrLifestyleBonus,
    PointsHistory,
    RankRequalification,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapGetters("rankQualification", {
      gtrLifeBonusList: "getGtrLifeBonus",
      expiringPoints: "getExpiringPoints",
      pointsHistory: "getPointsHistory",
      rankRequalification: "getRankRequalification",
    }),
    ...mapGetters("auth", {
      userProfile: "getUserProfile",
    }),
    ...mapGetters("ranks", {
      getRankById: "rankById",
    }),
    // `rankById` DECLARA que puede no encontrarlo (`Rank | undefined`) y estas dos
    // lo desreferenciaban a pelo, así que un rango ausente no dejaba la vista a
    // medias: reventaba el Tablero ENTERO con "can't access property
    // 'gtrLifeBonus', this.getRankById(...) is undefined".
    //
    // Y no es hipotético: el front carga SOLO los rangos `active`, mientras que
    // `currentRank` puede apuntar a uno RETIRADO. En el reinicio de red los 8
    // rangos viejos pasan a `inactive` en el paso 7, y hasta que la migración baja
    // a todo el mundo a INITIAL, cualquiera que estuviera en B600/INFLUENCER/
    // SIX-FIGURES/B300 abre esto y se lo encuentra roto. Cae dentro del freeze
    // (el front está offline), pero el operador SÍ mira, y parece que la migración
    // rompió algo cuando lo que falta es un guard de siempre.
    //
    // `rankNameById` (RanksStore.ts:58) ya lo comprueba. Un guard donde pensaron y
    // ninguno donde no: el mismo store, dos criterios.
    currentRankPriority(): number {
      // 0 = el peldaño más bajo. Un rango desconocido no debe colarse por delante
      // de nadie en una comparación de prioridad.
      return this.getRankById(this.userProfile.currentRank)?.priority ?? 0;
    },
    hasGtrLifeBonus(): boolean {
      // Sin rango conocido no se afirma que tenga bono: se dice que no, y la
      // sección no se pinta. Callar de más es recuperable; inventar un bono no.
      return this.getRankById(this.userProfile.currentRank)?.gtrLifeBonus
        ? true
        : false;
    },
  },
  methods: {
    async requestGtrLifeBonus() {
      await this.$store.dispatch("rankQualification/" + doGetGtrLifeBonus);
    },
    async requestExpiringPoints() {
      await this.$store.dispatch("rankQualification/" + doGetExpiringPoints);
    },
    async requestPointsHistory() {
      await this.$store.dispatch("rankQualification/" + doGetPointsHistory);
    },
  },
  async created() {
    await Promise.all([
      this.requestGtrLifeBonus(),
      this.requestExpiringPoints(),
      this.requestPointsHistory(),
    ]);
    this.loaded = true;
  },
});
